export const useTripInfo = () => {
    return {
        ...window.RESERVATION_STORE.tripBaseInfo
    }
};